import { Calculator, Type, Globe, Database, Brain, Settings, Play } from 'lucide-react';

export const getFlowIcon = (iconName: string) => {
  switch (iconName) {
    case 'calculator': return Calculator;
    case 'type': return Type;
    case 'globe': return Globe;
    case 'database': return Database;
    case 'brain': return Brain;
    case 'settings': return Settings;
    default: return Play;
  }
};